import { getTimeStamp, toServerDuration } from '@datadog/browser-core';
import { RumEventType } from '../../../rawRumEvent.types';
import { LifeCycleEventType } from '../../lifeCycle';
export function startLongTaskCollection(lifeCycle) {
    lifeCycle.subscribe(LifeCycleEventType.PERFORMANCE_ENTRY_COLLECTED, function (entry) {
        if (entry.entryType !== 'longtask') {
            return;
        }
        var rawRumEvent = {
            date: getTimeStamp(entry.startTime),
            long_task: {
                duration: toServerDuration(entry.duration),
            },
            type: RumEventType.LONG_TASK,
        };
        lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, {
            rawRumEvent: rawRumEvent,
            startTime: entry.startTime,
        });
    });
}
//# sourceMappingURL=longTaskCollection.js.map